module.exports = __webpack_public_path__ + "static/media/ServicesTrainingIcon.fe653944.svg";